/**
 * Schriftart und Schriftgröße der App-Oberfläche (Firmenprofil › Design, Freigabe Ralph 18.10.2026).
 * Die Schrift wirkt über die CSS-Variable --ew-font (index.css body, Tailwind font-sans),
 * die Größe über die Grundschriftgröße von <html> — Tailwind rechnet in rem, dadurch
 * wachsen Text und Abstände gleichmäßig mit.
 */
import { nachAlphabet } from './alphabetisch';

export const STANDARD_SCHRIFT = 'Nunito Sans';
export const STANDARD_SCHRIFTGROESSE = 18;
export const SYSTEMSCHRIFT = 'System';

// Google Fonts (nur Schriften mit guter Lesbarkeit in Formularen) + Systemschrift
export const APP_SCHRIFTEN = nachAlphabet([
  { value: 'Inter', label: 'Inter' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Nunito Sans', label: 'Nunito Sans (Standard)' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Source Sans 3', label: 'Source Sans 3' },
  { value: SYSTEMSCHRIFT, label: 'Systemschrift (Windows/macOS)' },
]);

export const APP_SCHRIFTGROESSEN = [
  { value: 15, label: 'Klein (15 px)' },
  { value: 16, label: 'Kompakt (16 px)' },
  { value: 17, label: 'Mittel (17 px)' },
  { value: 18, label: 'Normal (18 px, Standard)' },
  { value: 19, label: 'Groß (19 px)' },
  { value: 20, label: 'Sehr groß (20 px)' },
];

// Lädt eine Google-Schrift einmalig nach (Nunito Sans ist bereits in public/index.html eingebunden)
function ladeGoogleSchrift(familie) {
  if (!familie || familie === SYSTEMSCHRIFT || familie === STANDARD_SCHRIFT) return;
  const id = `ew-font-${familie.replace(/\s+/g, '-').toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(familie).replace(/%20/g, '+')}:wght@400;600;700;800&display=swap`;
  document.head.appendChild(link);
}

export function wendeAppSchriftAn(familie, groesse) {
  const root = document.documentElement;
  if (familie) {
    const bekannt = APP_SCHRIFTEN.some((s) => s.value === familie);
    if (!bekannt || familie === SYSTEMSCHRIFT) {
      // Systemschrift (oder unbekannter Wert): Schrift des Betriebssystems verwenden
      root.style.setProperty('--ew-font', 'system-ui');
    } else {
      ladeGoogleSchrift(familie);
      root.style.setProperty('--ew-font', `"${familie}"`);
    }
  }
  const px = Number(groesse);
  if (px >= 14 && px <= 20) root.style.fontSize = `${px}px`;
}
